import { useEffect } from 'react';

/**
 * Hook to dynamically update the theme-color meta tag based on current theme
 * This ensures the browser chrome (address bar, status bar) matches the app theme
 */
export function useThemeColor(isDark: boolean) {
  useEffect(() => {
    // Colors from your design system
    const lightColor = '#f97316'; // primary-500 orange
    const darkColor = '#0f172a';  // slate-900

    // Update the theme-color meta tag
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', isDark ? darkColor : lightColor);
    }

    // Update iOS status bar color (if in standalone mode)
    const statusBarMeta = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style]');
    if (statusBarMeta) {
      // black-translucent gives a frosted glass effect on iOS
      statusBarMeta.setAttribute('content', 'black-translucent');
    }
  }, [isDark]);
}
